import React from 'react';

export default function ConfirmModal(props) {
  var isDark = document.documentElement.classList.contains('tw-dark');
  var modal = props.modal;
  if (!modal) return null;

  var title = modal.title;
  var message = modal.message;
  var btnColor = modal.btnColor;
  var btnIcon = modal.btnIcon;

  var iconBg = btnColor === '#10B981' ? '#ECFDF5' : btnColor === '#6B7280' ? '#F3F4F6' : '#FEF2F2';

  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-p-4" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', zIndex: 60 }} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title" onKeyDown={function(e) { if (e.key === 'Escape') props.onCancel(); }}>
      <div className="tw-rounded-2xl tw-shadow-2xl tw-p-6 tw-max-w-sm tw-w-full" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
        <div className="tw-w-12 tw-h-12 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: iconBg }}>
          <i className={'fa ' + btnIcon + ' tw-text-xl'} style={{ color: btnColor }} />
        </div>
        <h3 id="confirm-modal-title" className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-text-center tw-m-0">{title}</h3>
        <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-text-center tw-mt-2 tw-mb-5">{message}</p>
        <div className="tw-flex tw-gap-3">
          <button
            className="tw-flex-1 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer"
            onClick={props.onCancel}
            disabled={props.loading}
            autoFocus
          >
            Cancel
          </button>
          <button
            className="tw-flex-1 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: btnColor }}
            disabled={props.loading}
            onClick={props.onConfirm}
          >
            {props.loading ? <i className="fa fa-spinner fa-spin" /> : title}
          </button>
        </div>
      </div>
    </div>
  );
}
